export const ServiceTokens = {
    UserRepository: 'IUserRepository',
    UserService: 'IUserService',
    CustomerRepository: 'ICustomerRepository',
    CustomerService: 'ICustomerService',
    ProjectService: 'IProjectService',
    SearchRepository: "ISearchRepository",
    SearchService: "ISearchService",
    DocumentRepository: 'IDocumentRepository',
    ProjectDraftRepository: 'IProjectDraftRepository',
    DeliveryRepository: 'IDeliveryRepository',
    LocalityRepository: 'ILocalityRepository',
    StoreRepository: 'IStoreRepository',
    ReportRepository: 'IReportRepository'
} 